import { render, staticRenderFns } from "./BoardDetailQnaLayout.vue?vue&type=template&id=a02a8e54&scoped=true"
import script from "./BoardDetailQnaLayout.vue?vue&type=script&lang=js"
export * from "./BoardDetailQnaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02a8e54",
  null
  
)

export default component.exports